/**
 * Resolves the event path based on the event name and version.
 * @function resolveEventPath
 * @param {string} eventName - The name of the event.
 * @param {number} [version] - The version of the event.
 * @returns {string} The resolved event path.
 */
const resolveEventPath = (eventName: string, version?: number) =>
  `${version ? `/v${version}/` : ''}${eventName}`;

/**
 * Resolves the namespace path based on the environment.
 * @function resolveNamespacePath
 * @param {boolean} isProduction - Whether the environment is production.
 * @returns {string} The resolved namespace path.
 */
const resolveNamespacePath = (isProduction: boolean) =>
  isProduction ? '/swap' : `/swap/development`;

export { resolveEventPath, resolveNamespacePath };
